import {fromJS, Map} from 'immutable';
import * as actionTypes from '../../actions/types';

const initialState = new Map({
  submitting: false,
  modelState: new Map(),
  model: new Map({
    email: '',
    password: ''
  })
});

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.RESET_LOGIN_FORM:
      return initialState;

    case actionTypes.SET_LOGIN_FORM_FIELD:
      return state.setIn(['model', action.payload.name], action.payload.value);

    case actionTypes.LOGIN_PENDING:
      return state.set('submitting', true);

    case actionTypes.LOGIN_FULFILLED:
      return initialState;

    case actionTypes.LOGIN_REJECTED:
      return state.withMutations(map => {
        map.set('submitting', false);

        if (action.payload.response.status === 401) {
          map.set('modelState', fromJS(action.payload.response.data));
        } else {
          map.set('modelState', initialState.get('modelState'));
        }
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/features/authentication/reducers/pages/logIn.js